import { useFormContext } from "react-hook-form";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@shared-kernel/primary/shared/shadcn/ui/form";
import { Input } from "@shared-kernel/primary/shared/shadcn/ui/input";
import type { StudentOnboardingFormInputs } from "../form-validation/full-form.schema";

export const ProfileStep = () => {
  const { control } = useFormContext<StudentOnboardingFormInputs>();

  return (
    <div className="space-y-4">
      <FormField
        control={control}
        name="stageName"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Nom de scène (optionnel)</FormLabel>
            <FormControl>
              <Input {...field} placeholder="Laissez vide si vous utilisez votre prénom et nom" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
